import { baseNormalizeData } from './baseNormalizeData';

export const normalizeContentViewsData = (data: any) => {
	const { contentAnalyticsViewers } = baseNormalizeData(data);

	return {
		count: contentAnalyticsViewers.count,
	};
};
